export enum EDealStatusType {
  Processing = 'Pending',
  Success = 'SUCCESS',
  Rejected = 'FAILED',
}
